import React from 'react';
import './about-me.scss';

const AboutMe = () => {
  return (
    <section id="about" className="about-area">
      <div className="container">
        <div className="row">
          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="profile">
              <img
                src={require('../../images/about/sanath_profile-pic.jpg')}
                alt="sanath kodikara"
                rel="noopener"
              />
            </div>
          </div>

          <div className="col-md-6 col-sm-6 col-xs-12">
            <div className="well-middle">
              Software Engineer with 10+ years of experience in the software
              development industry including 6+ years of Australian experience,
              enabling me to improve my professional skills and gain technical
              competencies. I have worked extensively with Angular JS, Node JS
              the related front-end technology stack. My experience in J2EE
              based technologies has allowed me to gain a good technical
              understanding about the total application architecture and the
              best practices required in end to end implementation of a business
              solution. I am passionate about the evolving front-end technology
              landscape and have been involved with some of the cutting-edge
              technologies in that domain.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;



// WEBPACK FOOTER //
// ./src/components/AboutMe/AboutMe.js